export const update_money_transition = `subscription update_money_transition{
    update_money_transition{
        transaction_code
        status
        from_account
        to_account
        amount
        currency
        transfer_date
        fulfillment_date
    }
}`;
